import { render, staticRenderFns } from "./StatsCardV3.vue?vue&type=template&id=a8cc35a4&"
import script from "./StatsCardV3.vue?vue&type=script&lang=js&"
export * from "./StatsCardV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatsCardV3.vue"
export default component.exports